import Link from "@/components/ui/intent-link";

import { ArrowRight } from "@/components/optilase/icons";
import { cn } from "@/lib/utils";

export function TextLink({
  href,
  target,
  onClick,
  children,
  className,
  arrowClassName,
}: {
  href?: string;
  target?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  className?: string;
  arrowClassName?: string;
}) {
  const shared = cn(
    "group inline-flex items-center gap-2 font-bold text-base whitespace-nowrap",
    className,
  );
  const inner = (
    <>
      <span className="underline-offset-4 group-hover:underline">{children}</span>
      <ArrowRight
        className={cn("shrink-0 transition-transform group-hover:translate-x-0.5", arrowClassName)}
      />
    </>
  );

  if (!href) {
    return (
      <button type="button" onClick={onClick} className={cn(shared, "cursor-pointer")}>
        {inner}
      </button>
    );
  }

  return (
    <Link
      href={href}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      className={shared}
    >
      {inner}
    </Link>
  );
}
